import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import { isAllowedReviewStatus } from 'utils/api';
import { hasClientAccess } from 'utils/clientSettings';
import {
  getResourceTypeExcludedToken,
  getResourceTypeFromGraphQLType,
} from 'components/ResourceItemSelector/utils';

export const filterAllowedLandingResources = (
  resources,
  clientDetails,
  ids,
  {
    isResourceTypeExcluded,
    isTopicExcluded,
    isAssessmentExcluded,
    isTopicExcludedById,
  },
) => {
  if (_isEmpty(resources)) return resources;

  return resources.filter(resource => {
    const reviewStatus = _get(resource, 'reviewStatus');
    if (!isAllowedReviewStatus(reviewStatus)) return false;

    const resourceType = getResourceTypeFromGraphQLType(
      _get(resource, '__typename'),
    );
    const finalType = getResourceTypeExcludedToken(resourceType, resource);
    const slug = _get(resource, 'slug');

    if (isResourceTypeExcluded(finalType)) return false;
    if (resourceType === 'topics' && isTopicExcluded(slug)) return false;
    if (resourceType === 'assessments' && isAssessmentExcluded(slug))
      return false;

    if (resourceType === 'list') {
      if (Array.isArray(resource?.client?.items)) {
        return resource.client.items.some(client =>
          ids.includes(client.sys.id),
        );
      }
      return true;
    }

    if (resourceType === 'series') {
      return hasClientAccess({
        item: {
          clientInclude: resource?.clientIncludeCollection?.items.map(
            el => el?.shortName,
          ),
          clientExclude: resource?.clientExcludeCollection?.items.map(
            el => el?.shortName,
          ),
        },
        clientDetails,
        paths: {
          includedClientsPath: 'clientInclude',
          excludedClientsPath: 'clientExclude',
        },
      });
    }

    const clientsExclude = _get(
      resource,
      'clientExcludeCollection.items',
      [],
    ).map(item => item.shortName);

    if (
      clientsExclude.length > 0 &&
      clientsExclude.includes(clientDetails.shortName)
    )
      return false;

    const clients = _get(resource, 'clientIncludeCollection.items', []).map(
      item => item.shortName,
    );
    if (clients.length > 0 && !clients.includes(clientDetails.shortName))
      return false;

    const topics = _get(resource, 'topicsCollection.items', []).map(
      item => item.sys.id,
    );
    if (
      topics.length > 0 &&
      topics.some(topicId => isTopicExcludedById(topicId))
    )
      return false;

    return true;
  });
};

export const applyFiltering = async (
  resources,
  { insuranceTags, state, filterLandingFeaturedResources },
) => {
  const basicFiltered = filterLandingFeaturedResources(
    resources,
    insuranceTags,
    state,
  );

  return basicFiltered;
};
